export default class Swipeable {
  constructor(container, items = null, nav = null) {
    // Container
    this.$container = $(container);
    if (!this.$container || this.$container.length == 0) return;

    // Items
    this.$items = items ? $(items) : this.$container.children();
    if (!this.$items || this.$items.length <= 1) return;

    // Nav
    this.$nav = nav ? $(nav) : null;

    // Current Slide
    this.current = 0;

    // Handle Nav Buttons
    this.handleNav();

    // Handle Swipe
    this.handleSwipe();

    // Toggle Nav Buttons
    this.toggleNav();
  }

  handleNav() {
    if (!this.$nav) return;

    this.$nav.click(e => {
      e.preventDefault();
      $(e.target).hasClass('next') ? this.swipeNext() : this.swipePrev();
    });
  }

  handleSwipe() {
    this.$container.swipe({
      swipeLeft: this.swipeNext.bind(this),
      swipeRight: this.swipePrev.bind(this),
    });
  }

  swipeNext() {
    if (this.current >= this.$items.length - 1) return;

    $(this.$items.get(this.current)).addClass('swiped swiped--left');

    this.current += 1;

    $(this.$items.get(this.current)).removeClass(
      'swiped--left swiped--right'
    );

    this.toggleNav();
  }

  swipePrev() {
    if (this.current <= 0) return;

    $(this.$items.get(this.current)).addClass('swiped swiped--right');

    this.current -= 1;

    $(this.$items.get(this.current)).removeClass(
      'swiped--left swiped--right'
    );

    this.toggleNav();
  }

  toggleNav() {
    if (this.current >= this.$items.length - 1) {
      this.$nav.filter('.next').hide();
    } else {
      this.$nav.filter('.next').show();
    }

    if (this.current <= 0) {
      this.$nav.filter('.prev').hide();
    } else {
      this.$nav.filter('.prev').show();
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/components/Swipeable.js